import React from 'react';
import { styled } from '@mui/system';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import companyLogo from '../icons/small-icon-light.png';
import { useMsal } from "@azure/msal-react";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1
}));

const LogoText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  marginTop: theme.spacing(1.5),
  fontSize: '1.1rem',
  fontWeight: 450
}));

const LogoImage = styled('img')(({ theme }) => ({
  height: 25,
  marginTop: theme.spacing(1)
}));

const HeaderContainer = styled('div')({
  display: "flex",
  width: "100%"
});

const AccountContainer = styled('div')(({ theme }) => ({
  marginLeft: "auto",
  marginTop: theme.spacing(1.4),
  marginRight: theme.spacing(2)
}));




export default function Header (props) {
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const [anchorEl, setAnchorEl] = React.useState(null);
    
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      event.preventDefault();
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    const logOut = async () => {
      await instance.logoutRedirect({
        account: instance.getActiveAccount(),
        authority: `https://login.microsoftonline.com/${instance.getActiveAccount() ? instance.getActiveAccount().tenantId : 'organizations'}`
      });
    }

    return <>
        <CssBaseline />
        <StyledAppBar position="fixed">
        <Toolbar>
          <HeaderContainer>
            <a href='/' title='Go to Service Bus Cloud Explorer'>
              <LogoImage alt="Cloudbricks.io logo" src={companyLogo} />
            </a>
            <LogoText variant="h5" noWrap>
              Service Bus Cloud Explorer
            </LogoText>
            {account && (
              <AccountContainer>
                <Link href="#" onClick={handleClick} color="inherit" sx={{textDecoration:'none', fontSize:'0.875rem'}}>
                  {account.username}
                </Link>
                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                >
                  <MenuItem onClick={logOut}>Logout</MenuItem>
                </Menu>
              </AccountContainer>
            )}
          </HeaderContainer>
        </Toolbar>
      </StyledAppBar>
    </>
};